<owl-carousel-o
  id="about"
  class="about-carousel h-52 md:h-[400px] lg:h-[600px]"
  [options]="customOptions"
>
  <ng-template id="firstSlideID" carouselSlide>
    <app-hero-section>
      @if (darkMode) {
        <picture class="h-full">
          <source
            media="(min-width: 1024px)"
            srcset="
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_darkmode@1x.avif 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_darkmode@1x.webp 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_darkmode@1x.avif 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_darkmode@1x.webp 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.avif      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.webp      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_darkmode@1x.avif        640w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_darkmode@1x.webp        640w
            "
            sizes="(max-width: 640px) 640px,
                               (max-width: 1024px) 1024px,
                               (max-width: 1440px) 1440px,
                               1920px"
            type="image/avif"
          />
          <img
            class="h-full w-full object-cover"
            src="https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_darkmode@1x.webp"
            alt="ayr_cities"
            fetchpriority="high"
          />
        </picture>
      } @else {
        <picture class="h-full">
          <source
            media="(min-width: 1024px)"
            srcset="
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_lightmode@1x.avif 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1900_extralargescreen_lightmode@1x.webp 1920w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_lightmode@1x.avif 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1600_extralargescreen_lightmode@1x.webp 1440w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.avif      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.webp      1024w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_lightmode@1x.avif        640w,
              https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_768_smallscreen_lightmode@1x.webp        640w
            "
            sizes="(max-width: 640px) 640px,
                                   (max-width: 1024px) 1024px,
                                   (max-width: 1440px) 1440px,
                                   1920px"
            type="image/avif"
          />
          <img
            class="h-full w-full object-cover"
            src="https://storage.googleapis.com/weayr-assets-non-prod/images/cities/ayr_cities_1200_largescreen_lightmode@1x.webp"
            alt="ayr_cities"
            fetchpriority="high"
          />
        </picture>
      }
    </app-hero-section>
  </ng-template>
  <!-- <ng-template id="secondSlideID" carouselSlide>
  <app-qsp-summit-section></app-qsp-summit-section>
</ng-template> -->
</owl-carousel-o>

<div
  class="max-w-screen-xl px-6 lg:px-32 py-8 lg:py-16 mx-auto w-full h-full gap-4 flex flex-col items-center justify-around dark:bg-black"
>
  <div class="flex flex-col items-center">
    <div
      class="gap-y-8 flex flex-col lg:items-start text-ayr-black dark:text-white"
    >
      <div class="flex flex-row row-start-1 col-start-1 col-span-2 lg:mb-3">
        <h2
          class="about-us-title text-27 lg:text-47 ayr-underline dark:text-shadow text-start inline lg:m-0 font-bold"
        >
          {{ "about.about-us" | translate }}
        </h2>
      </div>
      <p class="text-about-us lg:text-18 max-lg:text-center mb-auto w-full">
        {{ "about.description" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center w-full text-bold">
        {{ "about.first.title" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center mb-auto w-full">
        {{ "about.first.description" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center w-full text-bold">
        {{ "about.second.title" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center mb-auto w-full">
        {{ "about.second.description" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center w-full text-bold">
        {{ "about.third.title" | translate }}
      </p>
      <p class="text-about-us lg:text-18 max-lg:text-center mb-auto w-full">
        {{ "about.third.description" | translate }}
      </p>
    </div>
  </div>
</div>
